module.exports = function() {
	var list = [];
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};
	return list;
}


//////////////////
// WEBPACK FOOTER
// ../~/css-loader/cssToString.js
// module id = 275
// module chunks = 2 6 8 9 19 21 64 65 148